import {Table, Pagination} from "antd";
import {handleRequest, apiError, numberFormat} from "~/utils";
import {useContext, useState} from "react";
import {AppContext} from "~/context/AppProvider";
import {orderApi} from "~/api";
import {Button, Icon} from "~/components";
import "../../style/OrderTable.scss";
import OrderDetail from "./OrderDetail";

function OrderTable({items = [],
                        pagination,
                        onPaginationChange,
                        handlePrintBill,
                        detailsData,
                        setDetailsData,
                        detailsLoading,
                        setDetailsLoading}) {

    const {tableHeight, appData} = useContext(AppContext);

    const [expandedKeys, setExpandedKeys] = useState([]);

    const handleExpandDetails = async (record) =>
    {
        const recordId = record.id;

        const isExpanded = expandedKeys.includes(recordId);

        if (isExpanded) {
            setExpandedKeys([]);
            return;
        }

        if (!detailsData[recordId])
        {
            setDetailsLoading(prev => ({...prev, [recordId]: true}));

            let [error, response] = await handleRequest(orderApi.get(recordId));

            setDetailsLoading(prev => ({...prev, [recordId]: false}));

            if (!apiError('Lấy chi tiết đơn hàng thất bại', error, response))
            {
                setDetailsData(prev => ({
                    ...prev,
                    [recordId]: response?.data || {}
                }));
            }
        }

        setExpandedKeys([recordId]);
    };

    const columns = [
        {
            title: 'Mã đơn hàng',
            dataIndex: 'code',
            key: 'code',
            width: '150px',
            render: (_, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    <b>{record.code}</b>
                </div>
            )
        },
        {
            title: 'Thời gian',
            dataIndex: 'created',
            key: 'created',
            width: '180px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Mã khách hàng',
            dataIndex: 'customer_code',
            key: 'customer_code',
            width: '150px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {text || '-'}
                </div>
            ),
        },
        {
            title: 'Người bán',
            dataIndex: 'user_created_name',
            key: 'user_created_name',
            width: '150px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {text || '-'}
                </div>
            ),
        },
        {
            title: 'Tổng tiền hàng',
            dataIndex: 'subtotal',
            key: 'subtotal',
            width: '150px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {numberFormat(text)} đ
                </div>
            ),
        },
        {
            title: 'Giá trị đơn hàng',
            dataIndex: 'total',
            key: 'total',
            width: '150px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    <b className="color-blue">{numberFormat(text)} đ</b>
                </div>
            ),
        },
        {
            title: 'Hành động',
            key: 'action',
            width: '120px',
            render: (_, record) => (
                <Button
                    small
                    blue
                    background
                    leftIcon={Icon.print}
                    onClick={(e) => handlePrintBill(record, e)}
                    loading={detailsLoading[record.id]}
                >In bill</Button>
            ),
        },
    ];

    const dataSource = items.map(item => ({key: item.id, ...item}));

    return (
        <>
            <div className="table-wrapper">
                <div className="table-box">
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        scroll={{ y: tableHeight, x: 'max-content' }}
                        pagination={false}
                        size="middle"
                        rowClassName={(record) => expandedKeys.includes(record.id) ? 'order-row-expanded' : ''}
                        expandable={{
                            expandedRowKeys: expandedKeys,
                            onExpandedRowsChange: setExpandedKeys,
                            expandedRowRender: (record) => {
                                const details = detailsData[record.id] || {};
                                const isLoading = detailsLoading[record.id];
                                return <OrderDetail
                                    record={record}
                                    details={details}
                                    isLoading={isLoading}
                                    appData={appData}
                                />;
                            },
                        }}
                        onRow={(record) => ({
                            onClick: () => handleExpandDetails(record)
                        })}
                    />
                </div>
                <Pagination
                    current={pagination?.page}
                    defaultCurrent={1}
                    defaultPageSize={20}
                    pageSize={pagination?.limit}
                    total={pagination?.total}
                    onChange={onPaginationChange}
                    showSizeChanger={false}
                />
            </div>
        </>
    );
}

export default OrderTable;
